import { useLocation } from 'react-router-dom';

export function useUrlParams<T extends string>(paramKeys: T[]) {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const urlParamsDict: Partial<Record<T, string>> = {};
  paramKeys.forEach(paramKey => {
    urlParamsDict[paramKey] = urlParams.get(paramKey) || undefined;
  });
  return urlParamsDict;
}
